/**
 * `Autocomplete` is the `@erp/ui` Combobox under the name the frontend's
 * pickers already use. Pass translated strings with `pickerLabels`.
 */
export {
  Combobox as Autocomplete,
  type ComboboxProps as AutocompleteProps,
} from '@/components/ui/combobox';
